import React, { createContext, useState, useMemo, useContext, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import lightTheme from '../theme/lightTheme';
import darkTheme from '../theme/darkTheme';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const [mode, setMode] = useState(() => localStorage.getItem('themeMode') || 'light');
    const direction = i18n.dir();
  
    const theme = useMemo(() => {
      const baseTheme = mode === 'light' ? lightTheme : darkTheme;
      return createTheme({
        ...baseTheme,
        direction: i18n.dir(),
      });
    }, [mode, i18n.language]);
    const toggleTheme = () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    };

    const value = useMemo(() => ({ mode, toggleTheme }), [mode, toggleTheme]);
    return (
      <ThemeContext.Provider value={ value }>
        <MuiThemeProvider theme={theme}>
          {children}
        </MuiThemeProvider>
      </ThemeContext.Provider>
    );
  };
  

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};